<template>
    <div class="msg" ref="msg">
        <div class="top">
            <img src="../assets/imgs/warning.png"/>
            <p>安全告警</p>
            <p></p>
        </div>
        <el-form ref="form" :model="info" label-width="120px" class="forms">
            <el-form-item label="告警类型:" v-if="!info.warningStatus">
                <el-select
                        v-model="info.value"
                        placeholder=""
                        disabled
                        style="width: 100%"
                >
                    <template v-for="item in valueList">
                        <el-option :label="item.name" :value="item.value"></el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item label="告警类型:"  v-if="info.warningStatus">
                <el-input disabled placeholder="" v-if="info.deviceType == '07' " value="健康守护仪报警"></el-input>
                <el-input disabled placeholder="" v-if="info.deviceType == '06' " value="人体存在感知仪报警"></el-input>
                <el-input disabled placeholder="" v-if="info.deviceType == '09' " value="天与特征识别跌倒守护仪"></el-input>
            </el-form-item>
            <el-form-item label="告警状态:" v-if="info.warningStatus">
                <el-select
                        v-model="info.warningStatus"
                        placeholder=""
                        disabled
                        style="width: 100%"
                >
                    <el-option label="疑似跌倒" value="1000"></el-option>
                    <el-option label="确认跌倒" value="1001"></el-option>
                    <el-option label="长时间无人预警" value="1002"></el-option>
                    <el-option label="呼吸异常预警" value="2000"></el-option>
                    <el-option label="心率异常预警" value="2001"></el-option>
                    <el-option label="离床预警" value="2002"></el-option>
                    <el-option label="进入区域预警" value="3000"></el-option>
                    <el-option label="离岗预警 " value="3001"></el-option>
                    <el-option label="长时间无人预警" value="3002"></el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="告警状态:" v-if="!info.warningStatus">
                    <el-select
                            v-model="info.value"
                            placeholder=""
                            disabled
                            style="width: 100%"
                    >
                        <template v-for="item in valueList">
                            <el-option :label="item.label" :value="item.value"></el-option>
                        </template>
                    </el-select>
            </el-form-item>
            <el-form-item label="老人姓名:">
                <el-input
                        v-model="info.customerName"
                        disabled
                        placeholder=""
                ></el-input>
            </el-form-item>
            <el-form-item label="手机号:">
                <el-input
                        v-model="info.customerPhone"
                        placeholder=""
                        disabled
                        style="width: 88%"
                ></el-input>
                <i
                        class="el-icon-phone"
                        title="电话"
                        @click="callPhone(info.customerPhone, '1')"
                ></i>
            </el-form-item>
            <el-form-item label="详细地址:">
                <el-input
                        v-model="info.address"
                        disabled
                        type="textarea"
                        placeholder=""
                ></el-input>
            </el-form-item>
            <el-form-item label="服务站联系人:">
                <el-input
                        v-model="info.stationPhone"
                        placeholder=""
                        style="width: 88%"
                        disabled
                ></el-input>
                <i
                        class="el-icon-phone"
                        title="电话"
                        @click="callPhone1(info.stationPhone, '1')"
                ></i>
            </el-form-item>
            <div class="dialog-footer">
                <el-button @click="close()">取 消</el-button>
<!--                <el-button type="primary" @click="save()">确 定</el-button>-->
                <el-button type="primary" @click="close()">确 定</el-button>
            </div>
            <audio
                    id="audio"
                    src="../assets/imgs/audio.ogg"
                    ref="audio"
                    loop
                    controls
                    muted
                    autoplay
                    style="height: 0px"
                    v-if="Isaudio"
            ></audio>

            <!-- autoplay -->
        </el-form>
    </div>
</template>

<script>
    import request from "@/utils/request.js"
    import baseURL from "@/api/baseURL"
    import axios from "axios"
    import exportVue from "@/utils/exportVue"
    import {volunteerArchiveApi} from "../api/http"

    export default {
        name: "tymsg",
        mounted() {
        },
        data() {
            return {
                info: {},
                infos: {},
                List: [{id: 1, name: "2"}],
                rights: 40,
                bottoms: 30,
                wy: "",
                alldata: {},
                infoIndex: 0,
                Isaudio: false,
                connectError: false,
                allType: [],
                valueList:[
                        {value:"1",label:"摔倒报警",name:"摔倒报警器"},
                        {value:"2",label:"姿态异常报警",name:"摔倒报警器"},
                        {value:"3",label:"长时间滞留卫生间",name:"摔倒报警器"},
                        {value:"5",label:"长时间不去卫生间",name:"摔倒报警器"},
                        {value:"6",label:"固定时间未去卫生间",name:"摔倒报警器"},
                        {value:"7",label:"早间未去卫生间",name:"摔倒报警器"},
                        {value:"8",label:"晚间未去卫生间",name:"摔倒报警器"},
                        {value:"11",label:"长时间无人活动",name:"活动检测仪"},
                        {value:"12",label:"指定时间无人活动",name:"活动检测仪"},
                        {value:"13",label:"入室提醒",name:"活动检测仪"},
                        {value:"14",label:"生活习惯异常",name:"活动检测仪"},
                        {value:"17",label:"长时间离线",name:"所有设备"},
                        {value:"21",label:"一键呼叫报警(呼叫器)",name:"蓝牙呼叫器"},
                        {value:"400",label:"一键呼叫报警",name:"生命体征"},
                        {value:"1200",label:"摔倒报警（生命体征设备）",name:"生命体征"},
                        {value:"1201",label:"长时间未离床",name:"生命体征"},
                        {value:"1202",label:"夜间离床未归",name:"生命体征"},
                        {value:"1203",label:"生命体征异常报警",name:"生命体征"}
                ],
                typeList: [
                    {id: "1", name: "紧急按钮"},
                    {id: "2", name: "门磁"},
                    {id: "3", name: "烟感"},
                    {id: "4", name: "燃气"},
                    {id: "5", name: "水浸"},
                    {id: "6", name: "红外"},
                    {id: "7", name: "手环"},
                    {id: "8", name: "床垫"},
                    {id: "9", name: "血糖仪"},
                    {id: "10", name: "颐养卡"},
                    {id: "11", name: "血压计"},
                    {id: "12", name: "智能门锁"},
                    {id: "13", name: "摄像头"},
                    {id: "14", name: "跌倒"},
                    {id: "17", name: "SOS呼叫器"},
                    {id: "18", name: "定位器"}
                ],
                socket: null,
                lockReconnect: false,
                timeout: 30 * 1000, //30s一次心跳
                timeoutObj: null, //心跳倒计时
                serverTimeoutObj: null, //心跳心跳倒计时
                timeoutnum: null, //断开
            }
        },
        props: ["dialogsVisibleTy"],
        created() {
            //this.getTime()
            exportVue.$on("istrue", (data) => {
                if (data == true) {
                    this.time = setTimeout(() => {
                        this.common()
                    }, 50000)
                } else {
                    clearTimeout(this.time)
                }
            })
            this.getwebsocket()
        },
        beforeDestory() {
            this.socket.close()
            //清除时间
            clearTimeout(this.timeoutObj)
            clearTimeout(this.serverTimeoutObj)
        },
        methods: {
            getwebsocket() {
                var wsUrl =
                    "wss://" +
                    baseURL
                        .replace("https://", "")
                        .replace("/api", "") +
                    ":8099/websocket"
                //  var wsUrl = "ws://192.168.31.15:8099/websocket"
                this.socket = new WebSocket(wsUrl)
                this.socket.onerror = (event) => {
                    // console.log("websocket服务出错了")
                    this.reconnect(wsUrl)
                }
                this.socket.onclose = (event) => {
                    // console.log("websocket服务关闭了")
                    this.reconnect(wsUrl)
                }
                this.socket.onopen = (event) => {
                    // console.log(this.socket, "连接成功")
                    this.start() //开启心跳
                }
                this.socket.onmessage = (event) => {
                    //如果获取到消息，心跳检测重置
                    //拿到任何消息都说明当前连接是正常的
                    // console.log("websocket服务获得数据了", event)
                    // console.log('websocket服务获得数据了');

                    //接受消息后的UI变化
                    // console.log("接收消息")
                    // if (
                    //     JSON.parse(event.data).dataId ==
                    //     this.$store.state.info.dataId
                    // ) {
                    //
                    // this.infos = JSON.parse(event.data)
                    // this.allType.push(this.infos)
                    // if (this.allType.length == 1) {
                    //     console.log("是否再次点击")
                    //     this.Isaudio = true
                    //     this.info = this.allType[this.allType.length - 1]
                    //     this.info.type = String(this.info.type)
                    //     // alert(JSON.stringify( this.info))
                    //     this.$emit("tyclose", true)
                    // }
                    //  }
                    this.infos = JSON.parse(event.data)
                    let info = JSON.parse(event.data)
                    this.allType.push(this.infos)
                    // console.log( "1231123"+info)
                    // console.log( this.allType)
                    info.dataIds.forEach((item) => {
                        if (item == this.$store.state.orgId) {
                            // console.log(2)
                            if (this.allType.length == 1) {
                                // console.log("进来了")
                                this.Isaudio = true
                                this.info = this.allType[this.allType.length - 1]
                                this.info.type = String(this.info.type)
                                // alert(JSON.stringify( this.info))
                                this.$emit("tyclose", true)
                            }
                        }
                    })
                    this.reset() //收到服务器信息 心跳重置
                }
            },
            reconnect(url) {
                var that = this
                if (that.lockReconnect) {
                    return
                }
                that.lockReconnect = true
                //没连接上会一直重连 设置延迟避免请求过多
                that.timeoutnum && clearTimeout(that.timeoutnum)
                that.timeoutnum = setTimeout(function () {
                    that.getwebsocket() //新连接
                    that.lockReconnect = false
                }, 5000)
            },
            reset() {
                //重置心跳
                var that = this
                clearTimeout(that.timeoutObj)
                clearTimeout(that.serverTimeoutObj)
                that.start() //重启心跳
            },
            //心跳检测
            start() {
                var self = this
                self.timeoutObj && clearTimeout(self.timeoutObj)
                self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
                self.timeoutObj = setTimeout(function () {
                    // console.log(self.socket, "开始测试心挑")
                    //这里发送一个心跳，后端收到后，返回一个心跳消息，
                    //onmessage拿到返回的心跳就说明连接正常
                    self.socket.WebSocket.send("心跳测试")
                    //如果超过一定时间还没重置，说明后端主动断开了
                    self.serverTimeoutObj = setTimeout(function () {
                        //如果onclose会执行reconnect，我们执行ws.close()就行了.
                        //如果直接执行reconnect 会触发onclose导致重连两次
                        self.socket.close()
                    }, self.timeout)
                }, self.timeout)
            },
            callPhone(phone) {
                if (phone) {
                    this.$router.push({
                        name: "customerInfo",
                        params: {phone: phone},
                    })
                }
            },
            callPhone1(phone) {
                if (phone) {
                    this.$router.push({
                        name: "customerInfo",
                        params: {phone: phone},
                    })
                }
            },
            callPhone2(phone) {
                if (phone) {
                    this.$router.push({
                        name: "customerInfo",
                        params: {phone: phone},
                    })
                }
            },
            save() {
                axios({
                    method: "post",
                    url: baseURL + "/ypt/admin/warningInfo/info/saveWarningInfo",
                    data: {
                        remarks: this.info.remarks,
                        disposalStatus: 1,
                        msgKey: this.info.msgKey,
                    },
                })
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.$emit("tyclose", false)
                            clearTimeout(this.time)
                            this.Isaudio = false
                            this.allType.forEach((item, index) => {
                                if (item.msgKey == this.info.msgKey) {
                                    this.allType.splice(index, 1)
                                }
                            })
                            if (this.allType.length > 0) {
                                this.$emit("tyclose", true)
                                this.Isaudio = true
                                this.info = this.allType[this.allType.length - 1]
                                this.info.type = String(this.info.type)
                            }
                        }
                    })
                    .catch((error) => {
                        this.$message.error(res.data.mesage)
                        this.$emit("tyclose", false)
                        this.Isaudio = false
                        clearTimeout(this.time)
                    })
            },
            close() {
                this.common()
            },
            common() {
                this.$emit("tyclose", false)
                this.Isaudio = false
                this.allType.forEach((item, index) => {
                    if (item.msgKey == this.info.msgKey) {
                        this.allType.splice(index, 1)
                    }
                })
                if (this.allType.length > 0) {
                    this.$emit("tyclose", true)
                    this.Isaudio = true
                    this.info = this.allType[this.allType.length - 1]
                    this.info.type = String(this.info.type)
                } else {
                    this.$emit("tyclose", false)
                    this.Isaudio = false
                    clearTimeout(this.time)
                }
                //  `console.log(this.allType.length, "this.allType.length")
            },
        },
    }
</script>
<style lang='less' scoped>
    /deep/ .el-input {
        width: 100%;
    }

    .msg {
        position: fixed;
        z-index: 9999;
        // right: 40px;
        // bottom: 30px;
        width: 500px;
        border: 1px solid #b5b5b5;

        .top {
            background: #3f5292;
            height: 140px;
            width: 100%;
            text-align: center;

            p {
                color: #fff;
            }

            img {
                margin: 5px;
            }
        }

        .forms {
            padding: 20px 20px;
            background: #f5f5f5;

            .el-icon-phone {
                margin-left: 14px;
                cursor: pointer;
            }
        }
    }

    /deep/ .el-input__inner {
        background-color: #f5f5f5;
    }

    /deep/ .el-textarea__inner {
        background-color: #f5f5f5;
        color: #000000;
        font-weight: bold;
        font-size: 18px;
    }

    .dialog-footer {
        text-align: center;
    }

    /deep/ .el-button--primary {
        background-color: #3f5292;
        margin-left: 8px;
    }

    /deep/ .el-button--default {
        background: #9fa8c5;
        color: #fff;
    }

    /deep/ .el-button {
        padding: 8px 28px;
    }

    /deep/ .el-input.is-disabled .el-input__inner {
        color: #000000;
        font-weight: bold;
        font-size: 18px;
    }

    /deep/ .el-textarea.is-disabled .el-textarea__inner {
        color: #000000;
        font-weight: bold;
        font-size: 18px;
    }

    /deep/ .el-form-item__label {
        color: #000000;
    }
</style>
